import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";
import * as _ from "lodash";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { ReceiptOrder } from "../models/receipt.model";

import "firebase/firestore";
import { AngularFireFunctions } from "@angular/fire/functions";

@Injectable({
  providedIn: "root",
})
export class ReceiptOrderService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<ReceiptOrder>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private fns: AngularFireFunctions,
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getReceiptOrders(
    shopId: string,
    fromDate: Date,
    toDate: Date,
  ): AngularFirestoreCollection<ReceiptOrder> {
    return this.db.collection(
      this.dbPath + `/${shopId}/receipt-orders`,
      (ref) =>
        ref
          .where("isDeleted", "==", false)
          .where("isActive", "==", true)
          .where("issueDate", ">=", fromDate)
          .where("issueDate", "<=", toDate)
          .orderBy("issueDate", "desc"),
    );
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/receipt-orders`)
      .doc(id)
      .valueChanges();
  }

  getReceiptOrder(shopId: string, id: string) {
    var db = firebase.default.firestore();
    var ref = db.collection(this.dbPath + `/${shopId}/receipt-orders`).doc(id);

    return ref.get();
  }

  create(receipt: ReceiptOrder): any {
    let obj = _.clone(receipt);
    delete obj.id;
    obj.receiptOrderDetails =
      receipt.receiptOrderDetails.length > 0
        ? JSON.parse(JSON.stringify(receipt.receiptOrderDetails))
        : [];

    obj.isDelivered = false;
    obj.deliveredDate = new Date();

    obj.isActive = true;
    obj.isDeleted = false;
    obj.createdOn = new Date();
    obj.createdBy = this.userLogin.uid;
    obj.updatedOn = new Date();
    obj.updatedBy = this.userLogin.uid;
    obj.author = this.userLogin;
    obj.visibility = this.visibility;
    obj.timestamp = new Date().getTime();

    obj.shopId = obj.shopId ? obj.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipt-orders`,
    );

    console.log("create receipt:", obj);

    return this.collRef.add({ ...obj }).then((docRef) => {
      receipt.id = docRef.id;
      receipt.author = this.userLogin;
      return receipt;
    });
  }

  update(receipt: ReceiptOrder): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.collRef = this.db.collection(
      this.dbPath + `/${receipt.shopId}/receipt-orders`,
    );

    console.log("update receipt:", receipt);

    return this.collRef.doc(receipt.id).update({
      issueDate: receipt.issueDate,
      issueDateSeconds: receipt.issueDateSeconds,
      issueDateMinutes: receipt.issueDateMinutes,
      issueDateHours: receipt.issueDateHours,
      issueDateDay: receipt.issueDateDay,
      issueDateWeekDay: receipt.issueDateWeekDay,
      issueDateMonth: receipt.issueDateMonth,
      issueDateYear: receipt.issueDateYear,
      code: receipt.code ? receipt.code : "",
      note: receipt.note ? receipt.note : "",
      tags: receipt.tags ? receipt.tags : [],
      status: receipt.status,
      warehouseId: receipt.warehouseId ? receipt.warehouseId : "",
      warehouseName: receipt.warehouseName ? receipt.warehouseName : "",
      customerId: receipt.customerId ? receipt.customerId : "",
      customerName: receipt.customerName ? receipt.customerName : "",
      customerMobile: receipt.customerMobile ? receipt.customerMobile : "",
      customerAddress: receipt.customerAddress ? receipt.customerAddress : "",
      lastDebitAmount: receipt.lastDebitAmount ? receipt.lastDebitAmount : 0,

      totalDiscountAmount: receipt.totalDiscountAmount,
      detailDiscountAmount: receipt.detailDiscountAmount,
      discountAmount: receipt.discountAmount,
      discountPercent: receipt.discountPercent,
      detailAmount: receipt.detailAmount,
      detailNetAmount: receipt.detailNetAmount,
      totalQuantity: receipt.totalQuantity,
      totalAmount: receipt.totalAmount,
      vatPercent: receipt.vatPercent,
      vatAmount: receipt.vatAmount,
      points: receipt.points,
      ratePoints: receipt.ratePoints,
      isCancel: receipt.isCancel,
      isClosed: receipt.isClosed,
      isPrint: receipt.isPrint,
      noPrint: receipt.noPrint,
      isTrade: !!receipt.isTrade,
      totalCostAmount: receipt.totalCostAmount ? receipt.totalCostAmount : 0,
      totalProfit: receipt.totalProfit ? receipt.totalProfit : 0,

      isDebit: !!receipt.isDebit,
      isCash: receipt.isCash,
      paymentAmount: receipt.paymentAmount,
      paymentRefund: receipt.paymentRefund,
      paymentId: receipt.paymentId ? receipt.paymentId : "",
      receiptOrderDetails:
        receipt.receiptOrderDetails.length > 0
          ? JSON.parse(JSON.stringify(receipt.receiptOrderDetails))
          : [],

      employeeSaleId: receipt.employeeSaleId ? receipt.employeeSaleId : "",
      employeeSaleName: receipt.employeeSaleName
        ? receipt.employeeSaleName
        : "",

      employeeCounSellorId: receipt.employeeCounSellorId
        ? receipt.employeeCounSellorId
        : "",
      employeeCounSellorName: receipt.employeeCounSellorName
        ? receipt.employeeCounSellorName
        : "",

      employeeDeliveryId: receipt.employeeDeliveryId
        ? receipt.employeeDeliveryId
        : "",
      employeeDeliveryName: receipt.employeeDeliveryName
        ? receipt.employeeDeliveryName
        : "",

      isDelivery: !!receipt.isDelivery,
      deliveryDate: receipt.deliveryDate ? receipt.deliveryDate : new Date(),
      deliveryNote: receipt.deliveryNote ? receipt.deliveryNote : "",

      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }

  delete(shopId: string, id: string) {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(
      this.dbPath + `/${shopId}/receipt-orders`,
    );
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
